module.exports = __webpack_public_path__ + "assets/media/lunch.297e82fd.mp3";